












































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class BonusLargeIcon extends Vue {
  @Prop({ default: '191' }) readonly width?: string;
  @Prop({ default: '111' }) readonly height?: string;
}
